import React from 'react'
import {
  Stack,
  Heading,
  Text,
  useColorModeValue,
  ListItem,
  OrderedList,
  UnorderedList,
} from '@chakra-ui/react'
import RehypeReact from 'rehype-react'
// import { MDXProvider } from '@mdx-js/react'

export const Heading1 = ({ children }) => (
  <Heading
    as="h1"
    size="2xl"
    pt={6}
    pb={3}
    color={useColorModeValue('gray.700', 'gray.200')}
  >
    {children}
  </Heading>
)

export const Heading2 = ({ children }) => (
  <Heading
    as="h2"
    size="xl"
    pt={6}
    pb={3}
    color={useColorModeValue('gray.700', 'gray.200')}
  >
    {children}
  </Heading>
)

export const Heading3 = ({ children }) => (
  <Heading
    as="h3"
    size="lg"
    pt={6}
    pb={3}
    color={useColorModeValue('gray.700', 'gray.200')}
  >
    {children}
  </Heading>
)

export const Heading4 = ({ children }) => (
  <Heading
    as="h4"
    size="md"
    pt={6}
    pb={3}
    color={useColorModeValue('gray.700', 'gray.200')}
  >
    {children}
  </Heading>
)

export const Heading5 = ({ children }) => (
  <Heading
    as="h5"
    size="sm"
    pt={6}
    pb={3}
    color={useColorModeValue('gray.700', 'gray.200')}
  >
    {children}
  </Heading>
)

export const Heading6 = ({ children }) => (
  <Heading
    as="h6"
    size="sm"
    pt={6}
    pb={3}
    color={useColorModeValue('gray.700', 'gray.200')}
  >
    {children}
  </Heading>
)

export const Paragraph = ({ children }) => (
  <Text color={useColorModeValue('gray.700', 'gray.200')} pb={2}>
    {children}
  </Text>
)

export const components = {
  h1: Heading1,
  h2: Heading2,
  h3: Heading3,
  h4: Heading4,
  h5: Heading5,
  h6: Heading6,
  p: Paragraph,
  ul: UnorderedList,
  ol: OrderedList,
  li: ListItem,
}

export const renderAst = new RehypeReact({
  createElement: React.createElement,
  components,
}).Compiler

const TransformToChakra = ({ htmlAst }) => (
  <Stack spacing={6}>{renderAst(htmlAst)}</Stack>
)

export default TransformToChakra
